import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListItemValueRequest extends IBaseRequest {
  formInfo?: string;
  formItem?: string;
  formItemName?: string;
  context?: string;
  formId?: string;
  remoteId?: string;
  typ?: string;
}

export class ListItemValueRequest extends BaseRequest implements IListItemValueRequest {
  public formInfo?: string;
  public formItem?: string;
  public formItemName?: string;
  public context?: string;
  public formId?: string;
  public remoteId?: string;
  public typ?: string;

  constructor(server: string, session: string, formInfo?: string, formItem?: string, formItemName?: string, context?: string, formId?: string, remoteId?: string, typ?: string) {
    super(server, session);
    this.formInfo = formInfo;
    this.formItem = formItem;
    this.formItemName = formItemName;
    this.context = context;
    this.formId = formId;
    this.remoteId = remoteId;
    this.typ = typ;
  }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.formInfo, 'formInfo');
    parameters += this.makeNode(this.formItem, 'formItem');
    parameters += this.makeNode(this.formItemName, 'formItemName');
    parameters += this.makeNode(this.context, 'context');
    parameters += this.makeNode(this.formId, 'formId');
    parameters += this.makeNode(this.remoteId, 'remoteId');
    parameters += this.makeNode(this.typ, 'typ');

    return super.wrapperXml('ListItemValue', parameters);
  }
}
